module.exports = [
    { value: 'pending',     label: 'Noch nicht abgeschickt' },
    { value: 'submitted',     label: 'Abgeschickt (an Push API)' },
    { value: 'deleted',   label: 'Gelöscht' },
];
